import { RemotePayments } from '../../../data/usecases/payments/remote-payments'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makePayments = (userType: string) => new RemotePayments(
  `/${userType}/update-user-plan-subscription`,
  makeAxiosHttpClient(),
)
